import { render, staticRenderFns } from "./corporateForm.vue?vue&type=template&id=2d24c44b&scoped=true&"
import script from "./corporateForm.vue?vue&type=script&lang=js&"
export * from "./corporateForm.vue?vue&type=script&lang=js&"
import style0 from "./corporateForm.vue?vue&type=style&index=0&id=2d24c44b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d24c44b",
  null
  
)

export default component.exports